import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ConfigurationControllerService, MimeMessageDTO } from '@iota/iota-management-portal-v4-client';
import { MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { Store } from '@ngrx/store';
import { Subscription, withLatestFrom } from 'rxjs';
import { ResetSendMail, SendMail } from 'src/app/store/actions/notification.actions';
import { sendFailure, sending, sendSuccess } from 'src/app/store/reducer/notification.reducer';

export const INH_HEALTH_MAIL_FROM = 'health@inh.eu';

@Component({
    standalone: false,
    selector: 'app-dialog-send-mail',
    templateUrl: './dialog-send-mail.component.html',
    styleUrls: ['./dialog-send-mail.component.scss']
})
export class DialogSendMailComponent implements OnInit, OnDestroy {
    previewText = '';

    sending$ = this.store.select(sending);
    sendSuccess$ = this.store.select(sendSuccess);
    sendFailure$ = this.store.select(sendFailure);

    private closeSubscription: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA) public message: MimeMessageDTO,
        private dialogRef: MatDialogRef<DialogSendMailComponent>,
        private configApi: ConfigurationControllerService,
        private store: Store
    ) {}

    ngOnInit(): void {
        this.dialogRef.disableClose = true;
        this.previewText = this.message.text ?? '';
        this.configApi.configFile('inh-mail-signature.html').subscribe((signature) => {
            this.message.text += signature;
        });

        this.closeSubscription = this.sending$
            .pipe(withLatestFrom(this.sendSuccess$, this.sendFailure$))
            .subscribe(([sending, sendSuccess, sendFailure]) => {
                if (!sending && sendSuccess && !sendFailure) {
                    this.store.dispatch(ResetSendMail());
                    this.dialogRef.close(true);
                }
            });
    }

    ngOnDestroy(): void {
        if (this.closeSubscription) {
            this.closeSubscription.unsubscribe();
        }
    }

    sendMail(): void {
        // Convert string to array if needed
        if (typeof this.message.to === 'string') {
            this.message.to = [this.message.to];
        }
        this.store.dispatch(SendMail({ mail: this.message }));
    }

    isInvalid(): boolean {
        return (
            this.message.to === undefined ||
            this.message.to.length === 0 ||
            this.message.subject === undefined ||
            this.message.subject.trim().length === 0 ||
            this.message.text === undefined ||
            this.message.text.trim().length === 0
        );
    }
}
